const state = {
  clientCounters: {}
}

const getters = {
  countByType: state => (name) => {
    const c = state.clientCounters[name]
    return isNaN(c) || c < 0 ? 0 : c
  }
}

const mutations = {
  increment(state, name) {
    let count = state.clientCounters[name]
    count = isNaN(count) ? 0 : count
    state.clientCounters[name] = count + 1
  },
  decrement(state, name) {
    let count = state.clientCounters[name]
    count = isNaN(count) ? 0 : count
    state.clientCounters[name] = count - 1
  },
  setCounterData(state, data) {
    state.clientCounters = data
  }
}

const actions = {
  increment(context, name) {
    context.commit('increment', name)
  },
  decrement(context, name) {
    context.commit('decrement', name)
  },
  registerCounterData(context, data) {
    context.commit('setCounterData', data)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
